/**
 * VimeoPlayback
 * Add play/pause to autoplay/looping videos
 */
import Player from "@vimeo/player";

export function vimeoPlayback() {
  const playbackButtons = document.querySelectorAll("button.playback");
  if (!playbackButtons.length) {
    return;
  }

  playbackButtons.forEach((button) => {
    const targetSelector = button.dataset.target;
    if (!targetSelector) {
      return;
    }
    const iframe = document.querySelector(targetSelector);
    if (!iframe) {
      return;
    }

    const player = new Player(iframe);
    const label = button.querySelector(".visually-hidden");

    // Set initial accessible name from button class, correcting the default.
    if (label) {
      if (button.classList.contains("pause")) {
        label.textContent = "Pause video";
      } else {
        label.textContent = "Play video";
      }
    }

    button.addEventListener("click", () => {
      player.getPaused().then((paused) => {
        if (paused) {
          player.play();
        } else {
          player.pause();
        }
      });
    });

    player.on("play", () => {
      button.classList.add("pause");
      button.classList.remove("play");
      if (label) {
        label.textContent = "Pause video";
      }
    });

    player.on("pause", () => {
      button.classList.add("play");
      button.classList.remove("pause");
      if (label) {
        label.textContent = "Play video";
      }
    });
  });
}
